import React, { Component } from 'react';
import SubscriptionManager from './SubscriptionManager';
import shallowequal from 'shallowequal';
import * as r from 'ramda';

export default (servicesFrom) => (Wrapped) => {

  return class Wrapper extends Component {
    debug = false;
    services = {};
    subs = new SubscriptionManager();

    componentWillMount() {
      this.update(this.props);
    }

    componentWillReceiveProps(props) {
      this.update(props);
    }

    update(props) {
      if (!shallowequal(props, this.lastprops)) {
        this.lastprops = props;
        const services = servicesFrom(props);
        if (!shallowequal(services, this.services)) {
          this.unsubscribe();
          Object.keys(services).forEach(key => {
            if (key !== 'debug') {
              this.subs.subscribe(services[key], value => this.setState({
                [key]: value
              }))
            } else {
              this.debug = services['debug'];
            }
          })
          if (this.debug) console.log("Subscribing");
          this.services = services;
        }
      }
    }
    unsubscribe() {
      if (this.debug) console.log("Unsubscribing");
      this.subs.unsubscribe();
      this.setState(r.mapObjIndexed(() => null, this.state));
    }

    componentWillUnmount() {
      this.unsubscribe();
    }

    render() {
      return <Wrapped {...this.props} {...this.state}/>
    }
  };
}


// WEBPACK FOOTER //
// ./src/withSubscription.js